import { render } from "./CancelledOrders.vue?vue&type=template&id=4e95790a&scoped=true"
import script from "../js/cancelled-orders.js?vue&type=script&lang=js&external"
export * from "../js/cancelled-orders.js?vue&type=script&lang=js&external"

import "./CancelledOrders.vue?vue&type=style&index=0&id=4e95790a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e95790a"]])

export default __exports__